export enum TipoAlteracaoNFEnum {

  CARTA_CORRECAO = "Carta de Correção",
  SUBSTITUICAO = "Substituição"
}
